import {useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {useOverlayContext} from "../../contexts/OverlayContext";

const OverlayScreenQueryController = () => {
  const {setOverlayScreen, triggerProcessOverlay} = useOverlayContext();

  const [searchParams] = useSearchParams();
  const screen = searchParams.get("s");

  useEffect(() => {
    setOverlayScreen(screen);
    triggerProcessOverlay();
  }, [screen]);

  return null;
};

export default OverlayScreenQueryController;
